import {
  createBrowserRouter,
  RouterProvider,
  Routes,
  Route,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TriagePage } from "./pages/TriagePage";
import { DraftsPage } from "./pages/DraftsPage";
import { EmailsPage } from "./pages/EmailsPage";
import { EmailDetailPage } from "./pages/EmailDetailPage";
import { ThreadDetail } from "./components/ThreadDetail";
import { ChatPanel } from "./components/ChatPanel";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { NotificationPanel } from "./components/NotificationPanel";
import { LoginPage } from "./pages/LoginPage";
import { AdminPage } from "./pages/AdminPage";
import { HealthPage } from "./pages/HealthPage";
import { DemoRunsPage } from "./pages/DemoRunsPage";
import { DemoRunPage } from "./pages/DemoRunPage";
import { DemoCaseReviewPage } from "./pages/DemoCaseReviewPage";
import { AuthGuard } from "./components/AuthGuard";
import { useEffect, useState } from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";

const queryClient = new QueryClient();

function RoutedApp() {
  const [showNotifications, setShowNotifications] = useState(false);
  useEffect(() => {
    const open = () => setShowNotifications(true);
    window.addEventListener("vetmail-notifications", open);
    return () => window.removeEventListener("vetmail-notifications", open);
  }, []);

  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <AuthGuard>
              <TriagePage
                onNotificationClick={() => setShowNotifications(true)}
              />
            </AuthGuard>
          }
        />
        <Route
          path="/triage"
          element={
            <AuthGuard>
              <TriagePage
                onNotificationClick={() => setShowNotifications(true)}
              />
            </AuthGuard>
          }
        />
        <Route
          path="/drafts"
          element={
            <AuthGuard>
              <DraftsPage />
            </AuthGuard>
          }
        />
        <Route
          path="/cases/:caseId"
          element={
            <AuthGuard>
              <ThreadDetail />
            </AuthGuard>
          }
        />
        <Route
          path="/admin"
          element={
            <AuthGuard>
              <AdminPage />
            </AuthGuard>
          }
        />
        <Route
          path="/emails"
          element={
            <AuthGuard>
              <EmailsPage />
            </AuthGuard>
          }
        />
        <Route
          path="/emails/:emailId"
          element={
            <AuthGuard>
              <EmailDetailPage />
            </AuthGuard>
          }
        />
        <Route
          path="/system-health"
          element={
            <AuthGuard>
              <HealthPage />
            </AuthGuard>
          }
        />
        <Route
          path="/demo"
          element={
            <AuthGuard>
              <DemoRunsPage />
            </AuthGuard>
          }
        />
        <Route
          path="/demo/runs/:runId"
          element={
            <AuthGuard>
              <DemoRunPage />
            </AuthGuard>
          }
        />
        <Route
          path="/demo/runs/:runId/cases/:resultId"
          element={
            <AuthGuard>
              <DemoCaseReviewPage />
            </AuthGuard>
          }
        />
      </Routes>
      <ChatPanel />
      <NotificationPanel
        isOpen={showNotifications}
        onClose={() => setShowNotifications(false)}
      />
      <Toaster />
    </>
  );
}
const router = createBrowserRouter([{ path: "*", element: <RoutedApp /> }]);
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ErrorBoundary>
          <RouterProvider router={router} />
        </ErrorBoundary>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
export default App;
